import { useCallback, useEffect, useState } from "react";
import { useDebounce } from "../../../../helpers/useDebounce";
import { api } from "../../../../helpers/api";
import { MultiSelect } from "../../../../components/MultiSelect";

export const TopicSelect = ({ onChange, value, label }: any) => {
  const [categories, setCategories] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  const debouncedSearchValue = useDebounce(searchValue, 500);

  const fetchCategories = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.getTopics({
        page,
        limit: 1000,
        keyword: debouncedSearchValue,
      });
      setCategories([...(response?.data?.topic || [])]);
      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.error(error);
    }
  }, [page, debouncedSearchValue]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  console.log("value", value);
  return (
    <div className="flex flex-col gap-1.5">
      <label className="label text-black font-semibold text-sm">
        {label || "Category"}
      </label>
      <MultiSelect
        name="topic"
        onInputChange={(inputValue) => setSearchValue(inputValue)}
        options={categories?.map((category) => ({
          label: category.name,
          value: category.name,
        }))}
        onChange={onChange}
        value={value.map((v: any) => ({ value: v.value, label: v.label }))}
        multiValue={(base: any, data: any) => {
          const category = categories.find((c) => c.name === data.data.value);
          return {
            ...base,
            // backgroundColor: `${category?.bg_color_code} !important`,
          };
        }}
        renderLabel={(data, meta) => {
          const category = categories.find((c) => c.name === data.value);
          console.log({ category, data, meta, value });
          if (meta.context === "value") {
            return (
              <span
                style={
                  {
                    // color: category?.text_color_code,
                  }
                }
              >
                {data.label}
              </span>
            );
          }
          return (
            <div
              className={`h-[23px] w-fit px-2 py-1.5 bg-neutral-100 text-black text-[13px] font-medium rounded border border-black/5 justify-start items-center gap-1 flex`}
              style={{
                backgroundColor: category?.bg_color_code,
                color: category?.text_color_code,
              }}
            >
              {data.label}
            </div>
          );
        }}
      />
    </div>
  );
};
